'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ramda = require('ramda');

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/*
Take a local state transform and an object containing selector functions.

* The local state transform is a function that takes the global state and
  returns the appropriate sub-section of the state tree (aka local state).

* The selector functions are written to work with the local state.

Return a new object of selector functions.  The output selector functions now
work with the global state instead.

To do this, we map a `globalize` function over the selectors.

We assume that the state argument is always the last one, and we want to
transform it by applying the local state.  We use Ramda's `adjust` function
to do that.

The result of `globalize` is a function that takes the global state as its last
argument, transforms that state into local state, and then calls the original,
localized, selector.
*/

var globalize = function globalize(transform) {
  return function (selector) {
    return (0, _ramda.curryN)((0, _ramda.length)(selector), function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return selector.apply(undefined, _toConsumableArray((0, _ramda.adjust)(transform, -1, args)));
    });
  };
};

exports.default = function (localStateTransform, selectors) {
  return (0, _ramda.map)(globalize(localStateTransform), selectors);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/zeal-redux-utils/lib/globalizeSelectors.js
// module id = 1202
// module chunks = 0